module.exports = __webpack_public_path__ + "img/3.aa53ae6d.png";